
import { connect } from 'react-redux';
import FirebaseAuthcomponent from '../components/FirebaseAuthComponent';
import {
    loginFirebase, registerUserFirebase, setFirebasePopupOpen,
} from '../actions/ProfileActions';

const mapStateToProps = (state) => ({
    submitting: state.profile.submitting,
});

const mapDispatchToProps = (dispatch) => ({
    loginFirebase: (idToken, signInProvider) => {
        dispatch(loginFirebase(idToken, signInProvider));
    },
    registerUserFirebase: (idToken, signInProvider) => {
        dispatch(registerUserFirebase(idToken, signInProvider));
    },
    setFirebasePopupOpen: (firebasePopupOpen) => {
        dispatch(setFirebasePopupOpen(firebasePopupOpen));
    },
});

const LoginContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(FirebaseAuthcomponent);

export default LoginContainer;
